import * as React from "react";
import styles = require("./style.less");
import {FormSectionBase, FormSectionBaseProps} from "components/form/Sections/FormSectionBase";

interface FormSectionProps extends FormSectionBaseProps {
    title: React.ReactNode;
    help?: React.ReactNode;
}

export default class FormSection extends FormSectionBase<FormSectionProps> {
    constructor(props: FormSectionProps) {
        super(props);
    }

    render() {
        return <div className={styles.formSection}>
            <div>
                {this.title(this.props.title, this.help(this.props.help))}
            </div>
            {this.body(styles.cardMedia, false)}
            {this.moreInformation()}
        </div>;
    }
}
